export default class InputWithClearButton {
	constructor(input) {
		this.input = input;
		this.button = input.nextElementSibling;

		this.button.addEventListener('click', () => {
			this.input.value = null;
			this.input.focus();

			let passengerPlace = this.input.form.passenger_place;
			if (passengerPlace) passengerPlace.toggleHidden(false);
		});
	}
}
